module.exports = __webpack_public_path__ + "img/img_kb_type6_01.d1d27b5b.png";